module.exports = __webpack_public_path__ + "img/PostgreSQL.fcecdc9.svg";